// eslint-disable-next-line no-unused-vars
import {getiniinfo} from '@/api/user';
const state = {
  config: null,
};

const mutations = {
  SETCONFIG: (state, configData) => {
    state.config = configData;
  },
};

const actions = {
    getiniinfoFn({ commit }, response) {
    return new Promise((resolve, reject) => {
        getiniinfo(response)
        .then((res) => {
          console.log("系统配置",res.data)
          commit('SETCONFIG', res.data);
          resolve(res)
        })
        .catch((err) => {
          console.log(err);
          //   reject(err);
        });
    });
  },
};

export default {
  state,
  mutations,
  actions,
};
